import axios from 'axios';
import { env } from '../../../config/environment';

export const fetchProductById = async (id) => {
	try {
		const url = `${env.apiUrl}/products?ID=${id}`;
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error(`Error in fetching product:`, error);
	}
};

export const fetchProducts = async (id) => {
	try {
		const url = `${env.apiUrl}/products/company/all?company=${id}`;
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error(`Error in fetching products:`, error);
	}
};

export const updateProducts = async (body) => {
	try {
		const url = `${env.apiUrl}/products?ID=${body.id}`;
		const response = await axios.put(url, body);
		return response.data;
	} catch (error) {
		console.error(`Error in update products:`, error);
	}
};

export const createProducts = async (body) => {
	try {
		const url = `${env.apiUrl}/products`;
		const response = await axios.post(url, body);
		return response.data;
	} catch (error) {
		console.error(`Error in create products:`, error);
	}
};

export const createProductsList = async (body) => {
	try {
		const url = `${env.apiUrl}/products/list`;
		const response = await axios.post(url, body);
		return response.data;
	} catch (error) {
		console.error(`Error in create products list:`, error);
	}
};

export const fetchProductsByIds = async (ids) => {
	try {
		const url = `${env.apiUrl}/products/ids`;
		const response = await axios.post(url, { ids });
		return response.data;
	} catch (error) {
		console.error(`Error in fetching products by ids:`, error);
	}
};

export const fetchPromos = async (id) => {
	try {
		const url = `${env.apiUrl}/promos/company?company=${id}`;
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error(`Error in fetching promos:`, error);
	}
};

export const fetchPromosById = async (id) => {
	try {
		const url = `${env.apiUrl}/promos?ID=${id}`;
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error(`Error in fetching promos by ids:`, error);
	}
};

export const fetchPromosByIds = async (ids) => {
	try {
		const url = `${env.apiUrl}/promos/ids`;
		const response = await axios.post(url, { ids });
		return response.data;
	} catch (error) {
		console.error(`Error in fetching promos by ids:`, error);
	}
};

export const createPromo = async (body) => {
	try {
		const url = `${env.apiUrl}/promos`;
		const response = await axios.post(url, body);
		return response.data;
	} catch (error) {
		console.error(`Error in create promo:`, error);
	}
};

export const updatePromo = async (body) => {
	try {
		const url = `${env.apiUrl}/promos?ID=${body.id}`;
		const response = await axios.put(url, body);
		return response.data;
	} catch (error) {
		console.error(`Error in uodate promo:`, error);
	}
};
